import React, { useEffect } from 'react';
import { Button, notification, Space } from 'antd';
import { ArgsProps } from 'antd/lib/notification';
import { useTranslation } from 'react-i18next';
import { resolvePublicPath } from 'client/core/appConfig';

const STORAGE_KEY = 'cookieAgreed';
const CookiePolicyStorage = {
  set() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'agreed');
    } catch (e) {
      console.log(
        'Non è possibile salvare nel localStorage l’informazione di accettazione della cookie policy.'
      );
    }
  },
  agreed() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) == 'agreed' ?? false;
    } catch (e) {
      console.log(
        'Non è possibile leggere nel localStorage l’informazione di accettazione della cookie policy.'
      );
      return true;
    }
  }
};

export interface CookieNotificationProps {}

/**
 * Notifica di utilizzo Cookie.
 */
export function CookieNotification(props: CookieNotificationProps) {
  const { t } = useTranslation();

  const closeCookieNotification = () => {
    notification.close('cookie');
    CookiePolicyStorage.set();
  };

  const notificationMessage = (
    <Space direction="vertical" size={16}>
      <div>
        Questo sito utilizza cookie tecnici, analytics e di terze parti.
        <br />
        Proseguendo nella navigazione accetti l’utilizzo dei cookie.
      </div>
      <Space direction="horizontal">
        <a
          href={`${resolvePublicPath(
            t(
              'mic:footer.policy.privacy-cookie-policy-file-name',
              'privacy_e_cookie_policy.pdf'
            )
          )}`}
          target="_blank"
        >
          <Button>Informazioni</Button>
        </a>
        <Button type="primary" onClick={() => closeCookieNotification()}>
          Accetto
        </Button>
      </Space>
    </Space>
  );
  const notificationArgs: ArgsProps = {
    key: 'cookie',
    onClose: closeCookieNotification,
    placement: 'bottomRight',
    message: 'Cookie Policy',
    style: { width: 500 },
    description: notificationMessage,
    duration: 0
  };

  useEffect(() => {
    if (!CookiePolicyStorage.agreed()) {
      notification.open(notificationArgs);
    }
  }, []);

  return null;
}
